import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'

import { Card, Icon, Link, CardColors, Text, Image } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'

import { useReselector } from '@/utils/sharedHooks'
import { getGroupedActiveTaxEstimatesWithinActiveQuarter } from '@/features/taxes/quarterly-tax-estimates/userTaxEstimates.selector'
import { shortNames } from '@/constants/statesShortNamesConstants'

//TODO: Migrate to v2
import { STATE_QUARTERLY_TAX_PAYMENTS } from '@/featuresV1/Taxes/taxConstants'

export const StateSafeHarborCard = ({
  forLastQuarter,
}: {
  forLastQuarter?: boolean
}) => {
  const { stateTaxEstimates } = useReselector(
    getGroupedActiveTaxEstimatesWithinActiveQuarter
  )

  const bodyText = forLastQuarter
    ? "We’re unable to provide a safe harbor estimate for state taxes. However, we’ll provide a state estimate for the upcoming deadline when our Quarterly Checklist opens later this quarter. In the meantime, visit your state's website for information on how to calculate your estimated taxes."
    : "We’re unable to provide an estimate since it's so late in the quarter. However, we’ll provide you with your state estimate next quarter. In the meantime, visit your state's website for information on how to calculate your estimated taxes."

  return (
    <Card color={CardColors.LEVEL_1}>
      <div className="flex flex-col items-center lg:flex-row gap-4">
        {/* Left column: Image */}
        <Image
          src="https://heard-images.s3.amazonaws.com/assets/question_coin.svg"
          className="w-full lg:w-1/6 flex justify-center"
          alt="Question Coin"
        />

        {/* Right column: Content */}
        <div className="w-full lg:w-5/6 space-y-4">
          <Text variant={TypographyStyles.H2}>What about state taxes?</Text>

          <Text color={TextColors.MUTED}>{bodyText}</Text>

          {stateTaxEstimates?.map((estimate) => {
            const state = estimate.filingState
            const helpArticleLink =
              state && STATE_QUARTERLY_TAX_PAYMENTS[state]?.helpArticle
            const longName = state && shortNames[state]

            if (!helpArticleLink || !longName) return null

            return (
              <div key={estimate.id}>
                <Link href={helpArticleLink} newPage>
                  <Icon
                    icon={regular('square-arrow-up-right')}
                    className="mr-2 inline"
                  />
                  {longName} taxes
                </Link>
              </div>
            )
          })}
        </div>
      </div>
    </Card>
  )
}
